module.exports = __webpack_public_path__ + "static/media/test project10-6-2021-SRT_test_by_Dev_1634649900685.82588f66.vtt";